import { useNavigate } from 'react-router-dom'
import Pagination from 'components/Pagination/Pagination'
import { useTranslation } from 'react-i18next'
import { trackCtaClick } from 'services/analyticsService'

export const Delfos = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const casesData = [
    {
      id: 2,
      title: 'solutionsData_page.cases.items.fretesAnalytics.title',
      description: 'solutionsData_page.cases.items.fretesAnalytics.description',
      icon: '',
      url: 'fretes-analytics',
    },
    {
      id: 3,
      title: 'solutionsData_page.cases.items.kanban.title',
      description: 'solutionsData_page.cases.items.kanban.description',
      icon: '',
      url: 'kanban',
    },
    {
      id: 4,
      title: 'solutionsData_page.cases.items.fretesMachineLearning.title',
      description: 'solutionsData_page.cases.items.fretesMachineLearning.description',
      url: 'fretes-machine-learning',
    },
    {
      id: 5,
      title: 'solutionsData_page.cases.items.fretesInsights.title',
      description: 'solutionsData_page.cases.items.fretesInsights.description',
      icon: '',
      url: 'fretes-insights',
    },
    {
      id: 6,
      title: 'solutionsData_page.cases.items.integraSapIbp.title',
      description: 'solutionsData_page.cases.items.integraSapIbp.description',
      icon: '',
      url: 'integra-SAP-IBP',
    },
    {
      id: 7,
      title: 'solutionsData_page.cases.items.estruturaDadosHorizontal.title',
      description: 'solutionsData_page.cases.items.estruturaDadosHorizontal.description',
      icon: '',
      url: 'estrutura-de-dados-horizontal',
    },
    {
      id: 8,
      title: 'solutionsData_page.cases.items.qualidadeGovernanca.title',
      description: 'solutionsData_page.cases.items.qualidadeGovernanca.description',
      icon: '',
      url: 'qualidade-e-governanca',
    },
    {
      id: 9,
      title: 'solutionsData_page.cases.items.migracaoDatabricks.title',
      description: 'solutionsData_page.cases.items.migracaoDatabricks.description',
      icon: '',
      url: 'migracao-de-dados-databricks',
    },
  ]

  const handleRelatedCaseCtaClick = (caseItem) => {
    const ctaText = t('solutionsData_page.cases.cta')
    const caseTitle = t(caseItem.title)

    trackCtaClick({
      cta_name: 'data_case_related_case_click',
      cta_location: 'data_case',
      page_name: 'delfos',
      case_title: caseTitle,
      destination_path: `/${caseItem.url}`,
      cta_text: ctaText,
    })

    navigate(`/${caseItem.url}`)
  }

  return (
    <section className="main-container">
      <header className="main-container-top">
        <div className="text">
          <h2>{t('delfos_page.header.title')}</h2>
          <p>{t('delfos_page.header.description')}</p>
        </div>

        <div className="image-container">
          <img
            src="/assets/Cases/DataCases/notebook-datacase.png"
            alt={t('delfos_page.header.imageAlt')}
          />
        </div>
      </header>

      <div className="main-content">
        <div className="main-content-primary">
          <h2>{t('delfos_page.sections.benefits.title')}</h2>

          <ul>
            <li>
              {t('delfos_page.sections.benefits.items.item1.title')}
              <br />
              {t('delfos_page.sections.benefits.items.item1.description')}
            </li>

            <li>
              {t('delfos_page.sections.benefits.items.item2.title')}
              <br />
              {t('delfos_page.sections.benefits.items.item2.description')}
            </li>

            <li>
              {t('delfos_page.sections.benefits.items.item3.title')}
              <br />
              {t('delfos_page.sections.benefits.items.item3.description')}
            </li>

            <li>
              {t('delfos_page.sections.benefits.items.item4.title')}
              <br />
              {t('delfos_page.sections.benefits.items.item4.description')}
            </li>
          </ul>

          <h3>{t('delfos_page.sections.features.title')}</h3>

          <ul>
            <li>{t('delfos_page.sections.features.items.item1')}</li>
            <li>{t('delfos_page.sections.features.items.item2')}</li>
            <li>{t('delfos_page.sections.features.items.item3')}</li>
            <li>{t('delfos_page.sections.features.items.item4')}</li>
          </ul>

          <p>{t('delfos_page.sections.retailResult.intro')}</p>

          <ul>
            <li>{t('delfos_page.sections.retailResult.items.item1')}</li>
            <li>{t('delfos_page.sections.retailResult.items.item2')}</li>
            <li>{t('delfos_page.sections.retailResult.items.item3')}</li>
            <li>{t('delfos_page.sections.retailResult.items.item4')}</li>
          </ul>
        </div>
      </div>

      <section className="main-cases-container">
        <h2 className="title">{t('solutionsData_page.cases.title')}</h2>
        <span className="subtitle">{t('solutionsData_page.cases.subtitle')}</span>

        <Pagination data={casesData} itemsPerPage={4}>
          {(currentItems) => (
            <div className="main-cases-content">
              {currentItems.map((caseItem) => (
                <article key={caseItem.id} className="case-card">
                  <span className="icon">{caseItem.icon}</span>
                  <h3>{t(caseItem.title)}</h3>
                  <p>{t(caseItem.description)}</p>
                  <a
                    href={caseItem.link}
                    onClick={() => handleRelatedCaseCtaClick(caseItem)}
                  >
                    {t('solutionsData_page.cases.cta')} →
                  </a>
                </article>
              ))}
            </div>
          )}
        </Pagination>
      </section>
    </section>
  )
}

export default Delfos
